// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__wzXe-","content":"RecentSearches_content__1c-60"};